import { graphql } from "../generated";

export const SpecificationRevisionCapabilityDocument = graphql(`
  query SpecificationRevisionCapability($key: ID!) {
    specification(key: $key) {
      key
      canUpdateRevisions
    }
  }
`);
